import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'UI/res';

export const useFiltersStyles = makeStyles(
  theme => ({
    filtersWrapper: {
      padding: theme.spacing(1),
      backgroundColor: theme.palette.background.paper,
      '& hr': {
        margin: theme.spacing(2, 0)
      },
      '& hr:last-of-type': { display: 'none' }
    },
    footerButtonsContainer: {
      display: 'flex',
      position: 'sticky',
      flexDirection: 'column',
      padding: theme.spacing(1),
      gap: theme.spacing(1),
      bottom: 0,
      backgroundColor: theme.palette.background.paper
    },
    savedSearchActionsContainer: {
      marginTop: theme.spacing(1)
    },
    filtersContainer: {
      position: 'relative'
    },
    group: {
      marginBottom: theme.spacing(2),
      '&:last-of-type': {
        marginBottom: 0
      }
    },
    groupTitle: {
      display: 'block',
      margin: theme.spacing(0, -1),
      padding: theme.spacing(1, 1),
      marginBottom: theme.spacing(1.5),
      backgroundColor: colors.lightgrey,
      fontSize: theme.typography.caption.fontSize,
      textTransform: 'uppercase',
      letterSpacing: 0.5
    }
  }),
  { name: 'Filters' }
);

export const filterBaseStyles = theme => ({
  root: {
    marginTop: theme.spacing(1)
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1)
  },
  title: {
    color: theme.palette.text.primary
  },
  collapsedContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    userSelect: 'none',
    border: 'none',
    background: 'none',
    padding: 0,
    fontSize: 'inherit',
    fontFamily: 'inherit',
    cursor: 'pointer',
    '& > span:first-child': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 20,
      height: 20,
      fontSize: theme.typography.h6.fontSize,
      fontWeight: 300,
      lineHeight: 1,
      color: theme.palette.text.secondary,
      transition: 'color 0.2s'
    },
    '& > span:last-child': {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.body2.fontSize,
      transition: 'color 0.2s'
    },
    '&:hover': {
      '& > span': {
        color: theme.palette.primary.main
      }
    }
  },
  selectorsRow: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1)
  }
});
